export class RunLog {
    public contents: string[];

    public constructor() {
        this.contents = [];
    }
}
